<!-- イベント詳細画面 -->
<template>
  <div v-if="!isPreview">
    <HeaderComponent />
  </div>
  <div v-if="isInitError" id="com_form_contet1">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="apiErrorMessage" class="error-message">
        {{ apiErrorMessage }}
      </div>
    </div>
  </div>
  <div v-if="isDataFetched" id="contents1">
    <!-- エラーメッセージの表示エリア -->
    <div v-if="apiErrorMessage" class="application-error error-message">
      {{ apiErrorMessage }}
    </div>
  </div>
  <div v-if="isCategoryIdFetched" id="contents1">
    <section class="com_sec1">
      <div class="com_inner1 clearfix">
        <!-- パンくずリスト -->
        <BreadcrumbsComponent
          v-if="isCategoryIdFetched && !isPreview"
          :title="contentsData.title"
          :categoryId="contentsData.categoryId"
        />

        <div class="com_utl1">
          <div>
            <span class="com_date1 roboto">{{ contentsData.eventDate }}</span>
            <span class="com_category1">{{
              contentsData.subCategoryName
            }}</span>
            <span v-if="contentsData.newFlg" class="com_new1 roboto">NEW</span>
          </div>
          <div v-if="!isPreview">
            <a
              v-if="isKaunetAdmin"
              href="#"
              @click.prevent="
                copyContents(contentsData.categoryId, contentsData.contentsId)
              "
              class="com_s_button1"
            >
              <span class="text">
                <span class="text__item">参照新規</span>
                <span class="text__item" aria-hidden="true">参照新規</span>
              </span>
            </a>
            <a
              v-if="isKaunetAdmin"
              href="#"
              @click.prevent="
                editContents(contentsData.categoryId, contentsData.contentsId)
              "
              class="com_s_button2"
            >
              <span class="text">
                <span class="text__item">修正</span>
                <span class="text__item" aria-hidden="true">修正</span>
              </span>
            </a>
            <span
              v-if="contentsData.isFavorite"
              class="com_favorite1 selected"
              @click="handleToggleFavorite(contentsData)"
            ></span>
            <span
              v-else
              class="com_favorite1"
              @click="handleToggleFavorite(contentsData)"
            ></span>
          </div>
        </div>
        <!-- エラーメッセージの表示エリア -->
        <div v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
        <h1 class="com_d_title1">{{ contentsData.title }}</h1>

        <div v-if="contentsData.contentsImgList.length > 0">
          <div
            v-for="imgFile in contentsData.contentsImgList"
            :key="imgFile.rowNo"
            class="img-container"
          >
            <img
              v-if="imgFile.rowNo == 1"
              :src="`/${imgFile.imgPath}/${imgFile.imgName}`"
              :alt="imgFile.imgName"
            />
          </div>
        </div>

        <div v-if="contentsData.contentsVideoList.length > 0">
          <div>{{ contentsData.contentsVideoList[0].videoExp }}</div>
          <div :class="containerClass">
            <VideoPlayer
              v-for="(videoData, index) in contentsData.contentsVideoList"
              :key="videoData.rowNo"
              :videoSrc="`/${videoData.videoPath}/${videoData.videoName}`"
              :contentsId="contentsData.contentsId"
              screenName="イベント申し込み画面"
              :class="playerClass(index)"
              @half-watched="handleHalfWatched"
            />
          </div>
        </div>
        <div class="ql-editor" v-html="sanitizedContent"></div>

        <div v-if="isExistsLinkAreaItem" class="com_links1">
          <div v-if="contentsData.contentsLinkList.length > 0" class="item1">
            <div>
              <h3>リンク</h3>
            </div>
            <div>
              <ul
                v-for="link in contentsData.contentsLinkList"
                :key="link.rowNo"
                class="list1"
              >
                <li>
                  <a
                    v-if="isInternalLink(link.url)"
                    :href="`${link.url}`"
                    class="com_link1"
                    @click="regLinkClick(link.url)"
                    >{{ link.caption || link.url }}</a
                  >
                  <a
                    v-else
                    :href="`${link.url}`"
                    class="com_link1"
                    target="_blank"
                    @click="regLinkClick(link.url)"
                    >{{ link.caption || link.url }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="contentsData.contentsTempFileList.length > 0"
            class="item1"
          >
            <div>
              <h3>文書ファイル</h3>
              <a
                href="#"
                class="com_dl_button1"
                @click.prevent="
                  downloadFiles(
                    contentsData.categoryId,
                    contentsData.contentsId,
                    ''
                  )
                "
                ><span>全データダウンロード</span></a
              >
            </div>
            <div>
              <ul
                v-for="tmpFile in contentsData.contentsTempFileList"
                :key="tmpFile.rowNo"
                class="list2"
              >
                <li>
                  <a
                    :href="`/${tmpFile.tempFilePath}/${tmpFile.tempFileName}`"
                    class="com_link1"
                    target="_blank"
                    @click="regFileLinkClick(tmpFile.tempFileName)"
                    >{{ tmpFile.tempFileName }}</a
                  ><span v-if="tmpFile.tempFileSize" class="sub1">
                    ({{ tmpFile.tempFileSize }})</span
                  ><a
                    href="#"
                    class="com_dl_button2"
                    @click.prevent="
                      downloadFiles(
                        contentsData.categoryId,
                        contentsData.contentsId,
                        tmpFile.tempFileName
                      )
                    "
                    ><span>ダウンロード</span></a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          v-if="contentsData.contentsImgList.length > 0"
          class="img-container"
        >
          <div
            v-for="imgFile in contentsData.contentsImgList.slice(1)"
            :key="imgFile.rowNo"
          >
            <img
              :src="`/${imgFile.imgPath}/${imgFile.imgName}`"
              :alt="imgFile.imgName"
            />
          </div>
        </div>

        <div
          v-if="
            !contentsData.isRegistrationEnded && !contentsData.isApplication
          "
          class="sticky-banner"
        >
          <button
            type="button"
            name="btnApply"
            class="button1"
            @click.prevent="onApply"
          >
            申し込む
          </button>
        </div>
        <div
          v-if="!contentsData.isRegistrationEnded && contentsData.isApplication"
        >
          <button
            type="button"
            name="btnCancelApp"
            class="button2"
            @click.prevent="onCancel"
          >
            申し込みキャンセル
          </button>
        </div>
        <div v-if="contentsData.isRegistrationEnded" class="applyend-message">
          お申し込み受付を終了いたしました。
        </div>

        <a
          v-if="!isPreview"
          href="#"
          class="com_b_button1"
          @click.prevent="goback"
        >
          <span class="text">
            <span class="text__item">戻る</span>
            <span class="text__item" aria-hidden="true">戻る</span>
          </span>
        </a>
        <EventApplicationModal
          :isOpen="isOpenMessageModal"
          :title="modalTitle"
          :message="modalMessage"
          :addMessage="modalAddMessage"
          @closeModal="handlePreviewModalClosed"
        />
      </div>
    </section>
  </div>
  <div v-if="!isPreview">
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop v-if="!isPreview" />
</template>

<script lang="ts">
import { AxiosError } from "axios";
import { defineComponent, ref, onMounted, computed, PropType } from "vue";
import VideoPlayer from "../controls/VideoPlayer.vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import BreadcrumbsComponent from "../layout/BreadcrumbsComponent.vue";
import { useRouter } from "vue-router";
import { goBackToPreviousUrl } from "@/router";
import {
  outputDebugLogs,
  formatMessage,
  toggleFavoritePage,
  scrollToTop,
  getTargetDate,
  regRecentlyViewedHistory,
  isTokenAlive,
  sanitizeInput,
  regLinkClickLog,
  regFileLinkClickLog,
} from "@/Common";
import { useProcessingStore } from "../../store/useProcessingStore";
import { AppConstants } from "@/constants/AppConstants";
import messages from "@/assets/messages.json";
import apiAuthClient from "@/util/apiClientAuth";
import apiDownloadClient from "@/util/apiClientDownload";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import EventApplicationModal from "../layout/EventApplicationModalComponent.vue";

// ContentsLinkListModel
interface ContentsLinkListModel {
  rowNo: number;
  caption: string;
  url: string;
}

// ContentsVideoListModel
interface ContentsVideoListModel {
  rowNo: number;
  videoExp: string;
  videoPath: string;
  videoName: string;
}

// ContentsTempFileListModel
interface ContentsTempFileListModel {
  rowNo: number;
  tempFileExp: string;
  tempFilePath: string;
  tempFileName: string;
  tempFileSize: string;
}

// ContentsImgListModel
interface ContentsImgListModel {
  rowNo: number;
  imgExp: string;
  imgPath: string;
  imgName: string;
}

// Main Data Model
interface DataModel {
  categoryId: string;
  categoryName: string;
  subCategoryId: string;
  subCategoryName: string;
  contentsId: string;
  title: string;
  keisaiKikanStart: string;
  keisaiKikanEnd: string;
  newFlg: boolean;
  jyuyoFlg: boolean;
  lastUpdate: string;
  contentsBody: string;
  contentsLinkList: ContentsLinkListModel[];
  contentsVideoList: ContentsVideoListModel[];
  contentsTempFileList: ContentsTempFileListModel[];
  contentsImgList: ContentsImgListModel[];
  isFavorite: boolean;
  eventDate: string;
  isRegistrationEnded: boolean;
  isApplication: boolean;
}

export default defineComponent({
  name: "EventDetailComponent",
  components: {
    VideoPlayer,
    HeaderComponent,
    FooterComponent,
    BreadcrumbsComponent,
    BackToTop,
    EventApplicationModal,
  },
  props: {
    categoryId: {
      type: String as PropType<string>,
      required: true,
    },
    contentsId: {
      type: String as PropType<string>,
      required: true,
    },
    isPreview: {
      type: Boolean as PropType<boolean>,
    },
  },
  setup(props) {
    const videoPlayers = ref([]);
    const router = useRouter();
    const processingStore = useProcessingStore(); //状態管理ストア
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const errorMessage = ref(""); // エラーメッセージ
    const apiErrorMessage = ref(""); // エラーメッセージ（ページの真ん中にでるやつ）
    const isCategoryIdFetched = ref(false); // カテゴリIDが取得済みかどうかを追跡
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const isInitError = ref(false); // 初期表示時のエラーフラグ
    const serchCategoryId = ref(""); //検索用 カテゴリID
    const serchContentsId = ref(""); //検索用 コンテンツID
    const isPreviewMode = ref(false);
    const { logoutUser } = useUserStore();
    const sanitizedContent = ref(""); //サニタイジングされた本文
    const targetDate = ref("");
    const isOpenMessageModal = ref(false);
    const modalMessage = ref(""); // 完了画面メッセージ
    const modalAddMessage = ref(""); // 完了画面追加文言
    const modalTitle = ref(""); // 完了画面タイトル
    /**
     * イベントコンテンツデータの定義
     */
    const contentsData = ref<DataModel>({
      categoryId: "",
      categoryName: "",
      subCategoryId: "",
      subCategoryName: "",
      contentsId: "",
      title: "",
      keisaiKikanStart: "",
      keisaiKikanEnd: "",
      newFlg: false,
      jyuyoFlg: false,
      lastUpdate: "",
      contentsBody: "",
      contentsLinkList: [],
      contentsVideoList: [],
      contentsTempFileList: [],
      contentsImgList: [],
      isFavorite: false,
      eventDate: "",
      isRegistrationEnded: false,
      isApplication: false,
    });

    class EventModalMessage {
      static readonly MODAL_TITLE_APPLY = "イベントのお申し込みを受付ました";
      static readonly MODAL_TITLE_CANCEL =
        "イベントのお申し込みをキャンセルしました";
    }

    // 初期処理
    onMounted(async () => {
      outputDebugLogs("プロパティのカテゴリID: " + props.categoryId);
      outputDebugLogs("プロパティのコンテンツID " + props.contentsId);
      outputDebugLogs("プレビューか： " + props.isPreview);
      isPreviewMode.value = props.isPreview || false;
      serchCategoryId.value = props.categoryId;
      serchContentsId.value = props.contentsId;

      try {
        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;
          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
          }
          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        // イベント詳細取得API
        const response = await apiAuthClient.post(
          "/api/EventDetail/getEventDetail",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            categoryId: serchCategoryId.value,
            contentsId: serchContentsId.value,
            targetDate: getTargetDate(""),
          }
        );

        // レスポンスからコンテンツ詳細データを取得
        const data = response.data;
        contentsData.value = data;

        // 本文をサニタイジングする
        sanitizedContent.value = sanitizeInput(contentsData.value.contentsBody);
        // 閲覧履歴登録
        regRecentlyViewedHistory(
          agCode.value,
          userId.value,
          serchCategoryId.value,
          serchContentsId.value
        );
        isCategoryIdFetched.value = true; // カテゴリIDが取得されたことを設定
        isInitError.value = false;
      } catch (error: unknown) {
        isInitError.value = true;
        // エラー時は初期表示エラーフラグをON
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 403:
              // 取得件数オーバー
              apiErrorMessage.value = messages.ERR_0022;
              break;
            default:
              // その他のエラー
              apiErrorMessage.value = messages.ERR_SYS999;
          }
        } else if (axiosError.request) {
          apiErrorMessage.value = messages.ERR_SYS001;
        } else {
          apiErrorMessage.value = messages.ERR_SYS002;
          if (process.env.VUE_APP_DEBUG === "true") {
            console.log("Error: ", axiosError.message);
          }
        }
      }
    });
    /**
     * リンクエリアのデータが存在するか
     */
    const isExistsLinkAreaItem = computed(() => {
      return (
        contentsData.value.contentsLinkList.length > 0 ||
        contentsData.value.contentsTempFileList.length > 0
      );
    });

    /**
     * 動画が1件か複数か
     */
    const containerClass = computed(() => {
      return contentsData.value.contentsVideoList.length === 1
        ? "single-video"
        : "multiple-videos";
    });

    /**
     * ビデオプレイヤーの動的スタイル
     * @param index 動画のインデックス
     */
    const playerClass = (index: number) => {
      const videoCount = contentsData.value.contentsVideoList.length;
      const isOdd = videoCount % 2 !== 0;
      if (isOdd && index === videoCount - 1) {
        return "full-width";
      }
      return videoCount > 1 ? "half-width" : "full-width";
    };

    // お気に入り登録・解除
    const toggleFavorite = async (item: DataModel) => {
      // isProcessingがtrueなら処理をスキップ
      if (processingStore.isProcessing) {
        return;
      }
      processingStore.isProcessing = true;
      try {
        outputDebugLogs("コンテンツID：" + item.contentsId);

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        //お気に入り登録・解除
        const result = await toggleFavoritePage(
          item.categoryId,
          item.contentsId,
          item.isFavorite,
          "イベント申し込み画面"
        );

        if (!result) {
          errorMessage.value = formatMessage(
            messages.ERR_SYS003,
            item.isFavorite ? "お気に入り登録" : "お気に入り解除"
          );
        }

        // 状態を更新
        item.isFavorite = !item.isFavorite;
      } catch (error) {
        outputDebugLogs("Error toggling favorite:" + error);
      } finally {
        await new Promise((resolve) => setTimeout(resolve, 500));
        processingStore.isProcessing = false;
      }
    };

    const handleToggleFavorite = (item: DataModel) => {
      if (!processingStore.isProcessing) {
        toggleFavorite(item);
      }
    };

    /** 戻る処理 */
    const goback = () => {
      // もとの画面に戻る処理
      goBackToPreviousUrl();
    };

    const handleHalfWatched = () => {
      outputDebugLogs("A video has been watched halfway.");
    };

    /**
     * コンテンツ編集
     * イベント登録画面に編集モードで遷移します
     * ※イベント登録の未実装のため現在はコンテンツ登録画面へ遷移する
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const editContents = (ctgyId: string, ctsId: string) => {
      if (processingStore.isProcessing) {
        return;
      }
      processingStore.isProcessing = true;

      try {
        outputDebugLogs("カテゴリID: " + ctgyId);
        outputDebugLogs("コンテンツID: " + ctsId);

        // コンテンツ登録画面へ編集モードで遷移
        router.push({
          path: "/event-touroku",
          query: {
            categoryId: ctgyId,
            contentsId: ctsId,
            editMode: AppConstants.CONTENTS_EDIT_MODE_UPDATE,
          },
        });
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * コンテンツコピー
     * イベント登録画面に参照新規モードで遷移します
     * ※イベント登録の未実装のため現在はコンテンツ登録画面へ遷移する
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const copyContents = (ctgyId: string, ctsId: string) => {
      if (processingStore.isProcessing) {
        return;
      }
      processingStore.isProcessing = true;

      try {
        outputDebugLogs("カテゴリID: " + ctgyId);
        outputDebugLogs("コンテンツID: " + ctsId);

        // コンテンツ登録画面へ参照新規モードで遷移
        router.push({
          path: "/event-touroku",
          query: {
            categoryId: ctgyId,
            contentsId: ctsId,
            editMode: AppConstants.CONTENTS_EDIT_MODE_COPY,
          },
        });
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * ファイルダウンロード
     * @param ctgyId - カテゴリID
     * @param ctsId - コンテンツID
     */
    const downloadFiles = async (
      ctgyId: string,
      ctsId: string,
      flName: string
    ) => {
      // 何か処理中の場合は処理しない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // エラーメッセージ初期化
        errorMessage.value = "";

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // ファイルダウンロードAPI
        const response = await apiDownloadClient.post("/api/download", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          userId: userId.value,
          agCode: agCode.value,
          categoryId: ctgyId,
          contentId: ctsId,
          fileName: flName,
          targetDate: getTargetDate(""),
          pseudoUserId: pseudoUserId.value,
          pseudoAgCode: pseudoAgCode.value,
          screenName: "イベント申し込み画面",
        });

        // Content-Dispositionヘッダーからファイル名を取得
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "downloaded_file";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        // ダウンロードAPIエラー
        outputDebugLogs("Error downloading files: " + error);

        // エラーメッセージを表示
        errorMessage.value = formatMessage(
          messages.ERR_SYS003,
          "ファイルダウンロード"
        );

        // スクロールを一番上に戻す
        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /** 引数で渡されたURLが内部リンクか外部リンクかを判定します */
    const isInternalLink = (url: string): boolean => {
      try {
        // ベースURLのホスト名を正規表現で取得
        const baseUrl = process.env.VUE_APP_CLIENT_BASE_URL;
        const baseHostMatch = baseUrl.match(
          /^https?:\/\/([^/?#]+)(?:[/?#]|$)/i
        );

        if (!baseHostMatch) {
          return false;
        }
        const baseHost = baseHostMatch[1];

        // URLが相対パスであるか、ベースURLと同じホスト名を持つ場合は内部リンク
        const internalLinkPattern = new RegExp(
          `^(\\/|(?:https?:\\/\\/)?${baseHost}(?:[/:?#]|$))`,
          "i"
        );
        return internalLinkPattern.test(url);
      } catch (error) {
        outputDebugLogs("error" + error);
        return false;
      }
    };

    /**
     * リンククリックのログを出力します
     * @param linkUrl リンクURL
     */
    const regLinkClick = (linkUrl: string) => {
      regLinkClickLog(
        linkUrl,
        userId.value,
        agCode.value,
        pseudoAgCode.value,
        pseudoUserId.value,
        contentsData.value.contentsId,
        "イベント申し込み画面"
      );
    };

    /**
     * ファイルリンククリックのログを出力します
     * @param fileName ファイル名
     */
    const regFileLinkClick = (fileName: string) => {
      regFileLinkClickLog(
        fileName,
        userId.value,
        agCode.value,
        pseudoAgCode.value,
        pseudoUserId.value,
        contentsData.value.contentsId,
        "イベント申し込み画面"
      );
    };

    /**
     * 申し込む押下時
     */
    const onApply = async () => {
      try {
        // イベント申し込みAPI
        const response = await apiAuthClient.post(
          "/api/EventDetail/eventApplication",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            categoryId: contentsData.value.categoryId,
            contentsId: contentsData.value.contentsId,
            screenName: "イベント申し込み画面",
          }
        );

        // 完了画面を開く
        isOpenMessageModal.value = true;
        // モーダルのパラメーター
        modalTitle.value = EventModalMessage.MODAL_TITLE_APPLY;
        modalMessage.value = response.data.completeMessage;
        modalAddMessage.value = response.data.addMessage;

        // 申し込み済み状態にする
        contentsData.value.isApplication = true;
        document.body.classList.add("modal-open");

        isInitError.value = false;
      } catch (error: unknown) {
        isDataFetched.value = true;
        // エラー時は初期表示エラーフラグをON
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 400:
              // イベント受付期間外
              apiErrorMessage.value = formatMessage(
                messages.ERR_0030,
                "申し込み"
              );
              scrollToTop();
              break;
            default:
              // その他のエラー
              apiErrorMessage.value = formatMessage(
                messages.ERR_SYS003,
                "イベントの申し込み"
              );
              scrollToTop();
          }
        } else if (axiosError.request) {
          apiErrorMessage.value = messages.ERR_SYS001;
        } else {
          apiErrorMessage.value = messages.ERR_SYS002;
          if (process.env.VUE_APP_DEBUG === "true") {
            console.log("Error: ", axiosError.message);
          }
        }
      }
    };

    /**
     * 申し込みキャンセル押下時
     */
    const onCancel = async () => {
      try {
        // 申し込みキャンセルAPI
        const response = await apiAuthClient.post(
          "/api/EventDetail/eventApplicationCancel",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            categoryId: contentsData.value.categoryId,
            contentsId: contentsData.value.contentsId,
            screenName: "イベント申し込み画面",
          }
        );

        // 完了画面を開く
        isOpenMessageModal.value = true;
        modalTitle.value = EventModalMessage.MODAL_TITLE_CANCEL;
        modalMessage.value = response.data.completeMessage;
        modalAddMessage.value = "";

        // 申し込み可能状態にする
        contentsData.value.isApplication = false;
        document.body.classList.add("modal-open");

        isInitError.value = false;
      } catch (error: unknown) {
        isDataFetched.value = true;
        // エラー時は初期表示エラーフラグをON
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 422:
              // イベント受付期間外
              apiErrorMessage.value = formatMessage(
                messages.ERR_0030,
                "キャンセル"
              );
              scrollToTop();
              break;
            default:
              // その他のエラー
              apiErrorMessage.value = formatMessage(
                messages.ERR_SYS003,
                "イベントの申し込みキャンセル"
              );
              scrollToTop();
          }
        } else if (axiosError.request) {
          apiErrorMessage.value = messages.ERR_SYS001;
        } else {
          apiErrorMessage.value = messages.ERR_SYS002;
          if (process.env.VUE_APP_DEBUG === "true") {
            console.log("Error: ", axiosError.message);
          }
        }
      }
    };

    /**
     * プレビュー >> ダイアログ画面で戻る処理を実行
     */
    const handlePreviewModalClosed = async () => {
      isOpenMessageModal.value = false;
      document.body.classList.remove("modal-open");
    };

    return {
      videoPlayers,
      containerClass,
      playerClass,
      goback,
      isProcessing: processingStore.isProcessing,
      handleHalfWatched,
      isKaunetAdmin,
      contentsData,
      errorMessage,
      handleToggleFavorite,
      editContents,
      copyContents,
      isCategoryIdFetched,
      isDataFetched,
      isExistsLinkAreaItem,
      downloadFiles,
      isInternalLink,
      apiErrorMessage,
      isInitError,
      isPreviewMode,
      sanitizedContent,
      regLinkClick,
      regFileLinkClick,
      targetDate,
      isOpenMessageModal,
      modalTitle,
      modalMessage,
      modalAddMessage,
      onApply,
      onCancel,
      handlePreviewModalClosed,
    };
  },
});
</script>
<style scoped>
.video-container {
  width: 100%;
  margin-bottom: 20px;
}

.single-video .video-container {
  width: 100%;
}

.multiple-videos .video-container {
  float: left;
}

.half-width {
  width: 48%;
}

.full-width {
  width: 100%;
}

.half-width:nth-child(odd) {
  margin-right: 4%;
}

.multiple-videos {
  display: flex;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .half-width,
  .full-width {
    width: 100%;
    margin-right: 0;
  }
}

.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}

.application-error {
  width: 100%;
  text-align: center;
}

.button1 {
  background: #0053c0;
  border: 1px solid #0053c0;
  border-radius: 3px;
  color: #fff !important;
  display: block;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.03em;
  height: 65px;
  line-height: 36px;
  margin: 16px auto 0;
  overflow: hidden;
  position: relative;
  text-align: center;
  transition: 0.3s ease;
  width: 100%;
}
.button1:hover {
  background-color: #044ba8;
}
.button2 {
  background: #f53958;
  border: 1px solid #f53958;
  border-radius: 3px;
  color: #fff !important;
  display: block;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.03em;
  height: 65px;
  line-height: 36px;
  margin: 16px auto 0;
  overflow: hidden;
  position: relative;
  text-align: center;
  transition: 0.3s ease;
  width: 100%;
}
.button2:hover {
  background-color: #ec2647;
}
.applyend-message {
  background: #fcfcfc;
  border: 1px solid #a09c9c;
  border-width: 2px;
  border-radius: 3px;
  color: #ff0404 !important;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.03em;
  height: 65px;
  line-height: 36px;
  margin: 16px auto 0;
  width: 100%;
  display: flex;
  justify-content: center; /* 水平方向（左右）の中央揃え */
  align-items: center; /* 垂直方向（上下）の中央揃え */
}
.sticky-banner {
  position: sticky;
  bottom: 2%;
  left: 18%;
  width: 100%;
}
.img-container {
  margin-bottom: 20px;
}
</style>
